module.exports = __webpack_public_path__ + "media/vue/assets/images/qr-codes/ph_getapp-2c238281fcb81f12f1b43ece373ac761.png";